// Exports the "autosave" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/autosave')
//   ES2015:
//     import 'tinymce/plugins/autosave'
require('./plugin.js');


//////////////////
// WEBPACK FOOTER
// ./static/tinymce/plugins/autosave/index.js
// module id = oKZK
// module chunks = 3